(function () {
  /**
   * @awaitingdeprecation
   */
  angular
    .module('binky.core.common.selection')
    .constant('SELECTION_EVENT', {
      UPDATE: 'UpdateSelection',
    })
    .constant('SELECTION_STATE', {
      ALL: 'ALL',
      NONE: 'NONE',
      SUBSET: 'SUBSET',
    });
})();
